<template>
<v-app id="app">
	<h1
		style="z-index:100000;text-align:center;display:block;width: 100px;margin: 0 auto;user-select: none;"
		v-if="stage"
	>
		Test
	</h1>
	<v-navigation-drawer
		:absolute="true"
		v-show="$route.path.indexOf('login') == -1"
		v-model="drawer"
		fixed
		clipped
		class="grey lighten-4"
		app
	>
		<v-list
			dense
			class="grey lighten-4"
		>
			<template v-for="(item, i) in navigationByRole">
				<v-layout
					v-if="item.heading"
					:key="i"
					row
					align-center
				>
					<v-flex xs6>
						<v-subheader v-if="item.heading">
							{{ item.heading }}
						</v-subheader>
					</v-flex>
				</v-layout>
				<v-divider
					v-else-if="item.divider"
					:key="i"
					dark
					class="my-3"
				/>
				<v-list-tile
					v-else
					:key="i"
					:to="item.to"
				>
					<v-list-tile-action>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="grey--text">
							{{ item.text }}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</template>
		</v-list>
	</v-navigation-drawer>
	<v-toolbar color="primary" app absolute clipped-left
		v-show="$route.path.indexOf('login') == -1"
	>
		<v-toolbar-side-icon @click.native="drawer = !drawer"></v-toolbar-side-icon>
		<span class="title ml-3 mr-5" v-html="$t('common.site_name')"></span>

		<v-spacer></v-spacer>
		<h3>{{ $store.state.auth.name }}</h3>
		<v-menu
			v-model="menu"
			:close-on-content-click="false"
			:nudge-width="200"
			offset-x
		>
			<v-btn class="nav-avatar" slot="activator" icon small>
				<v-avatar size="40px" tile>
					<img
						v-if="avatar"
						:src="avatar"
						alt="Avatar"
					>
					<img v-else src="./assets/temp_user_logo.png" alt="avatar">
				</v-avatar>
			</v-btn>
			<v-card v-show="$route.path.indexOf('login') == -1">
				<v-list>
					<v-list-tile avatar>
						<v-list-tile-avatar>
							<img v-if="avatar"
								:src="avatar"
								alt="Avatar">
							<img v-else src="./assets/temp_user_logo.png" alt="avatar">
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>{{ $store.state.auth.name }}</v-list-tile-title>
							<v-list-tile-sub-title>
								{{ $store.state.auth.roles ? $t('roles.' + $store.state.auth.roles[0]) : '' }}
							</v-list-tile-sub-title>
						</v-list-tile-content>

					</v-list-tile>
				</v-list>

				<v-divider />

				<v-card-actions>
					<v-spacer />
					<v-btn flat @click="logout()">{{ $t('login.logOut') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu>
	</v-toolbar>
	<v-content>
		<v-container fluid fill-height class="grey lighten-4"
			:class="{ smallDevice1: $vuetify.breakpoint.xs }"
		>
			<v-layout max-width>
				<router-view v-title="title" />
			</v-layout>
		</v-container>
	</v-content>
	<notifications position="top center" group="main" />
	<handle-notify />
	<no-internet-connection />
</v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import HandleNotify from './components/HandleNotify'
import NoInternetConnection from './components/NoInternetConnection'
import apiConfig from '../config.js'

export default {
	name: 'app',
	components: {
		HandleNotify,
		NoInternetConnection,
	},
	data: vm => ({
		message: '',
		hints: true,
		isLoading: false,
		items: [],
		menu: null,
		model: null,
		search: null,
		drawer: null,
		title: vm.getTitle(vm.$route.meta),
		menuItems: [
			{ heading: vm.$t('navigation.database'), roles: ['admin', 'canPrepay', 'manager'] },
			{
				icon: 'recent_actors',
				text: vm.$t('navigation.workers'),
				to: '/workers',
				roles: ['admin', 'canPrepay', 'manager'],
			},
			{
				icon: 'work_outline',
				text: vm.$t('navigation.employers'),
				to: '/employers',
				roles: ['admin', 'manager'],
			},
			{
				icon: 'home',
				text: vm.$t('navigation.landlords'),
				to: '/landlords',
				roles: ['admin', 'manager'],
			},
			{
				icon: 'business_center',
				text: vm.$t('navigation.agencies'),
				to: '/agencies',
				roles: ['admin', 'manager'],
			},
			{
				icon: 'monetization_on',
				text: vm.$t('navigation.personal_finance'),
				to: '/personal-finance#output',
				roles: ['admin', 'manager', 'canPrepay'],
			},
			{ divider: true, roles: ['admin', 'canPrepay', 'manager'] },
			{ heading: vm.$t('navigation.agency'), roles: ['admin'] },
			{
				icon: 'supervisor_account',
				text: vm.$t('navigation.users'),
				to: '/users',
				roles: ['admin'],
			},
			{
				icon: 'euro_symbol',
				text: vm.$t('navigation.finance_reports'),
				to: '/reports',
				roles: ['admin'],
			},
			{
				icon: 'history',
				text: vm.$t('navigation.history'),
				to: '/history',
				roles: ['admin'],
			},
			{ divider: true, roles: ['admin'] },
			{ heading: vm.$t('navigation.settings_title'), roles: ['admin', 'manager'] },
			{
				icon: 'file_copy',
				text: vm.$t('navigation.templates'),
				to: '/templates',
				roles: ['admin', 'manager'],
			},
			{
				icon: 'settings',
				text: vm.$t('navigation.settings'),
				to: '/settings',
				roles: ['admin'],
			}
		]
	}),
	computed: {
		...mapGetters({ hasRole: 'auth/hasRole' }),
		navigationByRole() {
			return this.menuItems.filter(
				({ roles }) => !!roles.find(role => this.hasRole(role))
			)
		},
		avatar () {
			return this.$store.state.auth.avatar
		},
		stage() {
			return apiConfig.stage
		}
	},
	watch: {
		search(val) {
			if (this.items.length > 0) return
			this.isLoading = true
			// Lazily load input items
			this.$http
				.get('https://api.coinmarketcap.com/v2/listings/')
				.then(res => {
				this.items = res.data.data
				})
				.catch(err => {
				console.log(err)
				})
				.finally(() => (this.isLoading = false))
		},
		$route(to) {
			this.title = this.getTitle(to.meta)
		},
	},
	methods: {
		logout() {
			this.$store.dispatch('auth/logout').then(() => {
				this.$router.push('/login')
			})
		},
		getTitle({ title }) {
			return this.$t('navigation.' + title) + ' - ' + this.$t('common.site_title')
		}
	}
}
</script>

<style lang="stylus">
  html
    overflow auto !important
  #app
    .v-navigation-drawer__border
      display: none

  .vue-notification {
    padding: 10px;
    margin: 0 5px 5px;

    font-size: 12px;

    color: #ffffff;
    background: #44A4FC;
    border-left: 5px solid #187FE7;

    &.warn {
      background: #ffb648;
      border-left-color: #f48a06;
    }

    &.error {
      background: #E54D42;
      border-left-color: #B82E24;
    }

    &.success {
      background: #68CD86;
      border-left-color: #42A85F;
    }
    &.common {
      background: #323232;
      border-left-color: #323232;
      text-transform: uppercase;
      font-weight: bold;
    }
  }
  .smallDevice1 {
    padding 0 !important
  }
  .inputPrice input[type='number'] {
    -moz-appearance:textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
.nav-avatar {
	margin: 0px 0px 15px 15px !important;
	img {
		border-radius: 50% !important
	}
}
</style>
